import { getRequest } from '../services/requestHandler';
import { HeadWeightNumberBackDto } from '../models';

export const getHeadWeightNumberBack = async () => {
  const response = await getRequest<Omit<HeadWeightNumberBackDto, 'headWeightNumberBackId'>>('GetHeadWeightNumbersBack', 'headWeight/GetHeadWeightNumbersBack?useCache=false');
  return response.map((row, index) => ({ ...row, headWeightNumberBackId: index }));
};
